const getCookie = (cookie_name) => {
  var name = cookie_name + "=";
  var decoded_cookie = decodeURIComponent(document.cookie);
  var cookie_array = decoded_cookie.split(';');
  for (var i = 0; i < cookie_array.length; i++) {
    var cookie = cookie_array[i].trim();
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
};

const setCookie = (cookie_name, cookie_value) => {
  const url = require("./url");
  document.cookie = `${cookie_name}=${cookie_value};path=/;domain=${url.domain}`;
};

module.exports = { getCookie, setCookie };